import type React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { Avatar, Pill } from './ui';

export function Layout(): React.JSX.Element {
  const { admin, isSuperAdmin, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async (): Promise<void> => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="admin-shell">
      <aside className="sidebar">
        <div className="sidebar__brand">
          <span className="sidebar__logo">🃏</span>
          <span>Bostil Admin</span>
        </div>

        <nav className="sidebar__nav">
          <NavLink to="/" end className="nav-link">
            Visão geral
          </NavLink>
          <NavLink to="/users" className="nav-link">
            Usuários
          </NavLink>
          <NavLink to="/bots" className="nav-link">
            Bots
          </NavLink>
          <NavLink to="/messages" className="nav-link">
            Mensagens
          </NavLink>
          {isSuperAdmin ? (
            <NavLink to="/admins" className="nav-link">
              Administradores
            </NavLink>
          ) : null}
        </nav>

        <div className="sidebar__footer">
          {admin ? (
            <div className="sidebar__me">
              <Avatar src={null} name={admin.displayName} size={32} />
              <div className="sidebar__me-text">
                <div className="sidebar__me-name">{admin.displayName}</div>
                <Pill tone={isSuperAdmin ? 'accent' : 'neutral'}>
                  {isSuperAdmin ? 'super admin' : 'admin'}
                </Pill>
              </div>
            </div>
          ) : null}
          <button type="button" className="btn btn--ghost" onClick={() => void onLogout()}>
            Sair
          </button>
        </div>
      </aside>

      <main className="content">
        <Outlet />
      </main>
    </div>
  );
}
